"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _withScopeId = n => ((0, vue_1.pushScopeId)("data-v-74358ce4"), n = n(), (0, vue_1.popScopeId)(), n);
const _hoisted_1 = { class: "litigation-application-info local-main-page" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FlowEdit = (0, vue_1.resolveComponent)("FlowEdit");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createVNode)(_component_FlowEdit, {
            ref: "flow-edit",
            mainData: _ctx.mainData,
            flow: _ctx.flow.data,
            payload: { id: _ctx.currentParams.flowId },
            disabled: _ctx.isFinished,
            refuse: _ctx.flow.key !== _ctx.flow.data.getBuild(),
            onBack: _ctx.onBack
        }, null, 8, ["mainData", "flow", "payload", "disabled", "refuse", "onBack"])
    ]));
}
exports.render = render;
